// extracted by mini-css-extract-plugin
module.exports = {"list":"SetPrimaryContactModal_list__122BC"};